

export function svg_transform_rotateCenter(deg, centerX, centerY) {
    return ["transform", ((((("rotate(" + deg) + ", ") + centerX) + ", ") + centerY) + ")"];
}

export function svg_width(value) {
    return ["width", value];
}

export function svg_height(value) {
    return ["height", value];
}

export const style_outline_none = ["outline", "none"];

